import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from '../../hooks/useTranslation';

const AboutFAQ = () => {
    const { t } = useTranslation();
    
    const faqData = [
      {
        question: t('hoursOfOperation'),
        answer: (
          <div style={{ display: 'flex', flexDirection: 'column', width: '60%'}}>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('monday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('tuesday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('wednesday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('thursday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('friday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', padding: '8px 0' }}>
              <b>{t('saturday')}:</b> <span>9-22</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
              <b>{t('sunday')}:</b> <span>9-22</span>
            </div>
          </div>
        )
      },
        { question: t('whatKindOfFood'), answer: t('whatKindOfFoodAnswer') },
        { question: t('howToOrderOnline'), answer: t('howToOrderOnlineAnswer') },
    ];

    return (
        <div>
          <div style={{ paddingBottom: '40px', paddingTop: '40px' }}>
            <Typography variant='h2'>{t('frequentlyAskedQuestions')}</Typography>
          </div>
      
          <div>
            {faqData.map((faq, index) => (
              <Accordion key={index}
                sx={{ 
                  boxShadow: 'none',
                  paddingTop: '15px',
                  paddingBottom: '15px',
                  backgroundColor: 'transparent',
                  borderTop: index === 0 ? 'none' : '1px solid #ccc', // No top border for first item
                  borderBottom: index === faqData.length - 1 ? 'none' : '1px solid #ccc', // No bottom border for last item
                  borderLeft: 'none', // Remove left border
                  borderRight: 'none', // Remove right border
                  '&:before': {
                    display: 'none',
                  },
                  '&.Mui-expanded': {
                    margin: 'auto',
                  },
                }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}a-content`}
                  id={`panel${index}a-header`}
                >
                  <Typography>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant='subtitle1'>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      );
};

export default AboutFAQ;